import React from "react";
import styled from "styled-components";
import { get } from "lodash";
import PrismicRichText from "../components/PrismicRichText";
import * as colors from "../constants/colors";

const StlRoot = styled.section`
  padding: 20px 0px 12px;
  @media (min-width: 900px) {
    padding-top: 36px;
  }
`;

const StlCopyWrap = styled.div`
  margin: 0 auto;
  padding: 0 16px;
  @media (min-width: 900px) {
    padding: 0 48px 32px;
  }
`;

const StlCopy = styled.div`
  width: 100%;
  margin: 0 auto;
  text-align: center;
  h1,
  h2,
  h3 {
    margin: 0 0 24px 0;
  }
  @media (min-width: 900px) {
    h1,
    h2,
    h3 {
      margin: 0;
    }
  }
`;

const StlImageWrapper = styled.div`
  margin: 16px;
`;

const StlImage = styled.img`
  display: block;
  border-radius: 16px;
  min-height: 233px;
  width: 100%;
  margin: auto;
  max-width: 1000px;
  object-fit: cover;
  @media (min-width: 900px) {
    height: 576px;
  }
`;

const ColumnCopyImage = (slice) => {
  const copy = get(slice, "primary.copy");
  const imageUrl = get(slice, "primary.image.url");
  const imageAlt = get(slice, "primary.image.alt");

  if (!copy && !imageUrl) {
    return null;
  }

  return (
    <StlRoot
      style={{
        background: get(slice, "primary.background_color", colors.white),
        color: get(slice, "primary.text_color", colors.textDark),
      }}
    >
      {copy && (
        <StlCopyWrap>
          <StlCopy>
            <PrismicRichText render={copy} />
          </StlCopy>
        </StlCopyWrap>
      )}
      {imageUrl && (
        <StlImageWrapper>
          <StlImage src={imageUrl} alt={imageAlt} />
        </StlImageWrapper>
      )}
    </StlRoot>
  );
};

export default ColumnCopyImage;
